import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { CommonFieldManagerDirective, FIELD_TOKEN } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";
import { MultiselectStateService } from "./multiselect-state.service";

@Component({
    selector: "common-multiselect",
    templateUrl: "./common-multiselect.component.html",
    providers: [
        { provide: FieldStateService, useClass: MultiselectStateService },
        { provide: FIELD_TOKEN, useValue: "commonFormMultiselects" },
        CommonFieldManagerDirective,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonMultiselectComponent implements OnDestroy, AfterViewInit {
    public state$: Subscription;
    public selectedValue: { [key: string]: boolean } = {};
    public selectedLabel: string;

    constructor(
        public fieldManager: CommonFieldManagerDirective,
        public fieldStateService: FieldStateService,
    ) { }

    public ngAfterViewInit() {
        this.state$ = this.fieldStateService.stateObservable$.subscribe((state) => {
            this.selectedLabel = state.selectedLabel || this.selectedLabel;
            if (state.selectedValue) {
                const value = {};
                state.selectedValue.forEach((key) => value[key] = true);
                this.selectedValue = value;
            }
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    public get optionsExhausted() {
        if (!!this.fieldManager && this.fieldManager.fieldOptions) {
            return this.fieldManager.fieldOptions.length === 0;
        } else {
            return false;
        }
    }
}
